export default "__VITE_ASSET__BpbXLGW3__"